<!--
 * @Description: 站点配合比审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-21 11:48:14
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div>
              <div style="padding:20px 0">
                <span>生效日期：</span><span>{{fromDate.effectTime}}</span>
                <span style="padding-left:100px">站点：</span><span>{{fromDate.pointName}}</span>
              </div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="fromDate.itemList" tooltip-effect="dark">
                <el-table-column align="center" label="原物料" prop="materialName">
                </el-table-column>
                <el-table-column align="center" label="配合比" prop="radioValue">
                </el-table-column>
                <el-table-column align="center" label="误差范围(吨)" prop="errorRange">
                </el-table-column>
                <el-table-column label="操作状态" align="center">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.status===0" type="text" size="small" class="bottom_text">删除的数据</el-button>
                    <el-button v-else-if="!scope.row.id" type="text" size="small" class="bottom_text">新增的数据</el-button>
                    <el-button v-else-if="scope.row.isChanged" type="text" size="small" class="bottom_text" @click="showChange(scope.row)">修改数据</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="visible" width="1180px">
      <span slot="title" class="dialog-title">查看</span>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="oldTableData" tooltip-effect="dark">
        <el-table-column align="center" label="原物料" prop="materialName">
        </el-table-column>
        <el-table-column align="center" label="配合比" prop="radioValue">
        </el-table-column>
        <el-table-column align="center" label="误差范围(吨)" prop="errorRange">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '站点配合比审批',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      titlestatus: null,
      readOnly: false,
      visible: false,
      fromDate: {
        itemList: []
      },
      oldTableData: [],
    }
  },
  methods: {
    showChange (data) {
      const newData = this.fromDate.copyTableData.find(item => item.id === data.id);
      this.oldTableData = [newData];
      this.visible = true;
    },
    handleBusiness() {
      const { query } = this.$route;
      const params = {
        process_success: {
          url: '/icps/system/sign/basics/point/save_or_update',
          data: {
            ...JSON.parse(JSON.parse(query.dataContent).id),
          },
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    handleFinish() {
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'sign_mix',
        dataContent: JSON.stringify({ id: query.id, copyTableData: this.fromDate.copyTableData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    sendCode(code) {
      this.billCode = code;
    },
    formatList (data) {
      const newData = data.itemList.map(item => {
        if (item.id) {
          for (let i = 0; i < data.copyTableData.length; i+=1) {
            if (item.id === data.copyTableData[i].id) {
              if (item.materialName !== data.copyTableData[i].materialName || item.radioValue !== data.copyTableData[i].radioValue || item.errorRange !== data.copyTableData[i].errorRange) {
                return {...item, isChanged: true}
              }
            }
          }
        }
        return item
      })
      this.fromDate.itemList = newData;
    },
  },
  created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type)
  },
  async mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.$refs.flowcontent.initBaseData('sign_mix');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.fromDate = {...JSON.parse(query.id),copyTableData: JSON.parse(query.copyTableData)};
      this.applyPerson = await getUserInfo().userRealName;
      this.formatList(this.fromDate);
      return
    }
    this.fromDate = {...JSON.parse(JSON.parse(query.dataContent).id),copyTableData: JSON.parse(query.dataContent).copyTableData}
    this.title = query.taskName;
    this.billCode = query.receiptNumber;
    this.billDate = query.createTime;
    this.applyPerson = query.createUserName;
    this.taskStatus = query.taskStatus;
    this.formatList(this.fromDate);
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}
.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}
.bill_subtitle {
  padding: 20px 0;
  > span {
    padding-right: 20px;
  }
  .text {
    color: #000;
  }
}
.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.dialoginfo {
  padding: 0;
}
.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}
.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}
/*弹窗*/
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(
    180deg,
    rgba(250, 252, 255, 1) 0%,
    rgba(245, 247, 250, 1) 100%
  );
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);
  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>